import { apiCall } from '../../../Middleware/API/apiRequest';
import { getTokensFromStorage } from '../../../Utils/Auth/AuthToken';

const { accessToken } = getTokensFromStorage();
const routeName = '/affectedfiles';

/**
 * Lists Affected Files.
 * @returns {Promise} - A promise that resolves with the list of Affected Files or rejects with an error.
 * @param props
 */
export const listAffectedFiles = async ({
  limit,
  offset,
  filter,
  sort,
  includeBugSummary,
  signal,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const data = {
    Filters: Array.isArray(filter) ? filter : [],
    pageNumber: offset === 0 ? 1 : offset,
    pageSize: limit,
    sort: Array.isArray(sort) ? sort : [],
    includeBugSummary: Boolean(includeBugSummary),
  };
  const response = await apiRequest({
    url: `${routeName}`,
    method: 'POST',
    signal: signal ?? listController?.signal,
    moduleName,
    isServiceWorker,
    listController,
    body: JSON.stringify(data),
    accessToken,
  });

  if (!response?.isSuccess) {
    if (isServiceWorker) {
      let cacheResponse = await getGraphqlCacheResponse(
        headers,
        isServiceWorker
      );
      return cacheResponse;
    }
    return response;
  }
  if (isServiceWorker) {
    await setGraphqlCacheResponse(headers, response, isServiceWorker);
  }
  return {
    isSuccess: response?.isSuccess,
    affectedfiles: response?.payload,
    TotalCount: response?.totalRecordCount,
    summary:
      response?.summary ??
      response?.bugSummary ?? {
        totalBugCount: response?.totalBugCount ?? response?.totalBugs,
        bugSummaries: response?.bugSummaries ?? response?.bugs,
      },
  };
};

/**
 * Api Call Wrapper Method.
 * @param {object} api - Contains details like url headers method and data.
 * @returns {Promise} - A promise that resolves with the data or rejects with an error.
 */
const apiRequest = async (request) => {
  let response;
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };
  request.headers = headers;
  try {
    response = await apiCall(request);

    if (!response.isSuccess) {
      return { isSuccess: false, errorMessage: response.message };
    }
    return response;
  } catch (e) {
    response = { isSuccess: false, message: e.message };
  }
  return response;
};
